import { useState } from "react";
import { HTTP_STATUSES } from "@miplatform/constants";
import { createUUID } from "@miplatform/utils";
import { useComponentState } from "../useComponentState/useComponentState";

const getOrderTypesUUID = createUUID();

export const useOrderType = ({ service }) => {
  const [orderTypes, setOrderTypes] = useState([]);
  const stateManager = useComponentState();

  const getOrderTypes = () => {
    stateManager.abort(getOrderTypesUUID);
    stateManager.run(async () => {
      const response = await service.attemptTypes.getAll({
        sort: "name asc",
      });

      if (response.status === HTTP_STATUSES.OK) {
        setOrderTypes(
          response.data.map(({ id, name }) => ({ label: name, value: id }))
        );
      }
    }, getOrderTypesUUID);
  };

  return {
    loading: stateManager.isBusy(),
    orderTypes,
    getOrderTypes,
  };
};
